import React, { useEffect, useContext } from 'react'

import { CardContent, CardHeader, IconButton, Typography, Box, Grid } from '@mui/material/'

import { IoIosArrowBack } from 'react-icons/io'
import { ScheduleDaySlider } from '../../../Complex'
import { DiariaButton, InputButton, Loading } from '../../../Simple'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { PiChatCircleDots } from 'react-icons/pi'
import MiniCheckout from './miniCheckout'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'

export default function ListDiarias() {
  const { actionsCtxEmps, sttPg, loads } = useContext(EmpresasContext)
  const { sttCtxChkt, actionsChkt, loadCh } = useContext(CheckoutContext)

  useEffect(() => {
    actionsCtxEmps.handleSttPg('diaria', null)
    actionsCtxEmps.BuscarDiariasEmpresa()
  }, [sttPg.selectedDay])

  function SolicitarDiaria() {
    actionsChkt.AgendarDiaria()
  }
  return (
    <Box sx={stPg.containPageDiarias}>
      <CardHeader
        sx={stPg.containCardHeader}
        title={
          <Typography variant='h5' fontWeight='bold'>
            Marcação de diária
          </Typography>
        }
        avatar={
          <IconButton
            onClick={() => {
              if (sttCtxChkt.diaria) {
                actionsChkt.handleSttCtxChkt('diaria', null)
              } else {
                actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
              }
            }}
          >
            <IoIosArrowBack size='25px' color='#FF7043' />
          </IconButton>
        }
      />
      {loadCh.confirmarDiaria ? (
        <div className='contain-loading'>
          <Loading text={'Aguarde, estamos marcando sua diária...'} />
        </div>
      ) : (
        <CardContent sx={stPg.containCardContent}>
          <ScheduleDaySlider />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center',
              height: 'calc(100% - 81px)',
              width: '100%',
              borderTop: '1px solid #e0e0e0',
            }}
          >
            <Typography
              variant='h6'
              fontWeight='bold'
              color='primary.main'
              sx={{ padding: '10px 15px', width: '100%', textAlign: 'left' }}
            >
              Diária{sttPg.diaria ? ` - ${sttPg.diaria?.titulo}` : sttPg.diarias.length ? 's' : ''}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: 'calc(100% - 85px)',
                width: '100%',
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  flex: 'auto',
                  overflow: 'auto',
                  padding: '5px 10px',
                }}
              >
                {loads.diarias ? (
                  <div className='contain-loading'>
                    <Loading text={'Carregando diárias'} />
                  </div>
                ) : sttPg.diarias.length ? (
                  sttCtxChkt.diaria ? (
                    <Grid item xs={12} sx={{ padding: '5px' }}>
                      <DiariaButton diaria={sttCtxChkt.diaria} isSelected={sttCtxChkt.diaria} />
                    </Grid>
                  ) : (
                    sttPg.diarias.map((diaria, index) => (
                      <Grid item xs={12} key={index} sx={{ padding: '0px' }}>
                        <DiariaButton diaria={diaria} />
                      </Grid>
                    ))
                  )
                ) : (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        height: 'auto',
                        width: '100%',
                      }}
                    >
                      <PiChatCircleDots size={50} color='#424242' />
                    </Box>
                    <Typography variant='body1' align='center' color={'text.secondary'}>
                      Nenhuma diária disponível neste dia
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
            {sttCtxChkt.diaria && <MiniCheckout />}
            <InputButton
              sx={{ height: 'auto', width: 'calc(100% - 20px)', marginTop: '5px' }}
              disabled={
                sttCtxChkt.diaria &&
                !sttCtxChkt.selPix &&
                !sttCtxChkt.selCartao &&
                !sttCtxChkt.selDinheiro
              }
              onClick={() => {
                if (
                  sttCtxChkt.diaria &&
                  (sttCtxChkt.selPix || sttCtxChkt.selCartao || sttCtxChkt.selDinheiro)
                ) {
                  SolicitarDiaria()
                }
              }}
            >
              {!sttCtxChkt.diaria
                ? 'Selecione uma diária'
                : !sttCtxChkt.selPix &&
                    !sttCtxChkt.selCartao &&
                    !sttCtxChkt.selDinheiro &&
                    sttCtxChkt
                  ? 'Selecione a forma de pagamento'
                  : 'Marcar diária'}
            </InputButton>
          </Box>
        </CardContent>
      )}
    </Box>
  )
}

const stPg = {
  containPageDiarias: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  containCardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '10px',
  },
  containCardContent: {
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'calc(100% - 61px)',
    width: '100%',
    padding: '0px',
  },
}
